import { Box, Flex } from "grid-styled";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { color } from "styled-system";

import { P } from "./text";

const copyrightYear = new Date().getFullYear();

const FooterFlexContainer = styled(Flex).attrs({
  bg: "nav.95",
  align: "center",
  justify: "center",
  flexDirection: "column",
  width: "100%",
  py: 9
})`
  ${color};
`;

const Logo = styled.img`
  max-width: 200px;
`;

const Copyright = () => {
  const { t } = useTranslation();
  return (
    <P color="nav.25" size="tiny">
      {t("footer.copyright", { year: copyrightYear })}
    </P>
  );
};

const Footer = () => (
  <FooterFlexContainer id="footer">
    <Box>
      <Logo
        src={`${window.S3_IMG_URL}rldatix-policystat-logo.png`}
        alt="rldatix policystat logo"
      />
    </Box>
    <Box>
      <Copyright />
    </Box>
  </FooterFlexContainer>
);

export default Footer;
